const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  formContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  surveyCard: {
    backgroundColor: "#fff",
    height: 146,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    cursor: "pointer",
    "&:hover": {
      transform: `scale(0.98)`,
    },
  },
  filterCard: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    marginBottom: 18,
  },
  displayCard: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  },
  actions: {
    ...theme.borderTop,
    paddingTop: 10,
    marginTop: 10,
  },
  surveyTitle: {
    marginTop: 4,
  },
  userHeader: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 20,
  },
  content: {
    ...theme.mainContentMD,
  },
  emptyWrap: {
    background: "#fff",
    padding: "15px",
    width: "100%",
    borderRadius: 8,
  },
  resCard: {
    backgroundColor: "#fff",
    padding: 16,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    // marginBottom: 18,
    ...theme.borderBottom,
  },
  resFooter: {
    // ...theme.borderTop,
    // paddingTop: 10,
    marginTop: 10,
    display: "flex",
    gap: 10,
    justifyContent: "flex-end",
  },
  rating: {
    display: "flex",
    listStyle: "none",
    margin: 0,
    padding: 0,
    gap: 10,
  },
  resBody: {
    paddingTop: 10,
  },
  surveyCardDisabled: {
    background: "#bdbdbd",
    pointerEvents: "none",
  },
  statWrap: {
    display: "flex",
  },
  statCard: {
    height: 36,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  overviewCard: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    "&:not(:last-child)": {
      marginBottom: "25px",
    },
  },
  borderBottom: {
    "&:not(:last-child)": {
      ...theme.borderBottom,
    },
  },
  overCard: {
    backgroundColor: "#fff",
    padding: 16,
    ...theme.borderBottom,
  },
  statValue: {
    ...theme.typography.semiBold,
    fontSize: 10,
  },
  overviewFooter: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    justifyContent: "flex-end",
    marginTop: 10,
  },
  overviewFooterJustify: {
    justifyContent: "space-between",
  },
  statContainer: {
    borderRadius: 10,
    overflow: "hidden",
    marginTop: 10,
  },
  ratingWrap: {
    display: "flex",
    marginBottom: 24,
  },
  ratingContainer: {
    position: "sticky",
    top: 58,
  },
  ratingItem: {
    width: `20%`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 36,
  },
  chartWrap: {
    background: "#fff",
    marginTop: 10,
  },
  headlineCard: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    "&:not(:last-child)": {
      marginBottom: "25px",
    },
  },
  headlineHeader: {
    display: "flex",
    gap: 10,
    alignItems: "center",
  },
  headlineList: {
    marginTop: 18,
  },
  headlineQue: {
    width: "80%",
  },
  headlineRating: {
    width: "20%",
    textAlign: "right",
  },
  headlineWrap: {
    "&:not(:last-child)": {
      marginBottom: "10px",
    },
  },
  lableCard: {
    display: "flex",
    gap: 20,
    alignItems: "center",
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  },
  cardPositive: {
    backgroundColor: "#9CD0FF",
  },
  cardNeutral: {
    backgroundColor: "#c9c9c9",
  },
  cardNegative: {
    backgroundColor: "#f9bbbb",
  },
  headlineProgress: {
    marginTop: 18,
  },
  statusMenu: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  statusMenuItem: {
    backgroundColor: "#fff",
    padding: "7px 12px",
    ...theme.border,
    borderRadius: 5,
    cursor: "pointer",
    textTransform: "capitalize",
  },
  statusMenuItemSelected: {
    backgroundColor: "#C5E3FF",
  },
  specList: {
    display: "flex",
    listStyle: "none",
    gap: 10,
    margin: 0,
    padding: `8px 0px 0px 0px`,
  },
  specItem: {
    display: "flex",
    gap: 4,
  },
  commonFilterCard: {
    backgroundColor: "#fff",
    padding: `12px 16px`,
    borderRadius: 8,
    boxShadow:
      "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 18,
  },
  filterList: {
    display: "flex",
    listStyle: "none",
    alignItems: "center",
    margin: 0,
    padding: 0,
  },
  listItem: {
    background: "#fff",
    padding: "6px 20px",
    ...theme.typography.b1,
    cursor: "pointer",
    "&:not(:first-child)": {
      borderLeft: "1px solid #bebebe",
      paddingLeft: 20,
    },
    "&:not(:last-child)": {
      paddingRight: 20,
    },
    display: "flex",
    gap: 4,
    alignItems: "center",
    whiteSpace: "pre",
    textTransform: "capitalize",
  },
  listItemSelected: {
    fontWeight: 700,
    backgroundColor: "#C5E3FF",
  },
  barPositive: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#9CD0FF",
    },
  },
  barNeutral: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#c9c9c9",
    },
  },
  barNegative: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#f9bbbb",
    },
  },
  tabContent: {
    marginTop: 18,
  },
  reportCard: {
    display: "none",
    "@media print": {
      display: "block",
      marginBottom: 18,
    },
  },
  actionHeader: {
    marginBottom: 18,
  },
  input: {
    display: "none",
  },
  actionCard: {
    padding: `12px 24px`,
    borderRadius: 0,
  },
  planTable: {
    marginTop: 18,
  },
  progress: {
    height: 8,
    borderRadius: 8,
    marginTop: 4,
  },
  tableContainer: {
    display: "flex",
    width: "100%",
  },
  tableHeader: {
    borderBottom: "1px solid rgba(195, 194, 194, 0.54)",
  },
  tableHead: {
    width: "14.3%",
    background: "#fff",
    padding: "16px",
    display: "flex",
    gap: 5,
  },
  tableHeadLG: {
    width: "40%",
    background: "#fff",
    padding: "16px",
    display: "flex",
    gap: 5,
  },
  questionCell: {
    display: "flex",
    alignItems: "center",
    gap: 5,
  },
  tableRow: {
    "&:not(:last-child)": {
      borderBottom: "1px solid rgba(195, 194, 194, 0.54)",
    },
  },
  tableRowFw: {
    width: "100%",
    background: "#fff",
    padding: "16px",
    display: "flex",
    justifyContent: "center",
  },
  resHeader: {
    display: "flex",
  },
  resHeaderItem: {
    flex: "1",
  },
  tableActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 18,
  },
  commentCard: {
    marginLeft: -6,
  },
  commentSwitcher: {
    marginBottom: 4,
    "@media print": {
      display: "none",
    },
  },
  commentWrapper: {
    "@media print": {
      display: "none",
    },
  },
  headerActions: {
    display: "flex",
    gap: 10,
  },
  templateCard: {
    ...theme.border,
    display: "flex",
    borderRadius: 4,
    backgroundColor: "#   ",
    "&:not(:last-child)": {
      marginBottom: "15px",
    },
    padding: "8px",
    cursor: "pointer",
  },
  templateSelected: {
    backgroundColor: "rgb(237 244 255)",
  },
  chartCard: {
    padding: 18,
  },
  overallChart: {
    maxWidth: 300,
    margin: "0 auto",
  },
  pieChart: {
    maxWidth: 160,
    margin: "0 auto",
    minHeight: 200,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 12,
    alignItems: "center",
  },
  meanCardWrap: {
    "@media print": {
      display: "block",
    },
  },
  meanCardWrapHidden: {
    "@media print": {
      display: "none",
    },
  },
  reportItem: {
    "@media print": {
      width: "calc(100% - 20px)",
      margin: "10px",
    },
  },
  optionItem: {
    backgroundColor: "#f0f0f0",
    padding: "8px",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&:not(:last-child)": {
      marginBottom: "15px",
    },
  },
  synopsisCard: {
    marginTop: "18px",
    padding: "15px",
  },
}));
